(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/game-analyses-redux/assets/game-analyses-actions.js') >= 0) return;  svs.modules.push('/components/sportinfo/game-analyses-redux/assets/game-analyses-actions.js');
"use strict";


const {
  createAsyncThunk,
  createAction
} = RTK;
const {
  getDrawAnalyses
} = svs.content.shared.cms;
const {
  normalizeAnalyses
} = svs.components.sportinfo.gameAnalysesRedux.normalizeAnalyses;
const {
  normalizeDrawData,
  normalizeDrawDataFromAnalyseData
} = svs.components.sportinfo.gameAnalysesRedux.normalizeDrawData;
const {
  products
} = svs.utils;
const {
  log
} = svs.core;
const logger = log.getLogger('game-analyses-redux:game-analyses-actions');
const {
  ApiProxy,
  http,
  featureToggle
} = svs.components.lbUtils.apiProxy;
const {
  cloudApiFeatureToggles
} = svs.components.lbUtils.cloudApi.cloudApiConstants;
const fetchDrawAnalyses = createAsyncThunk('gameAnalyses/fetchDrawAnalyses', async _ref => {
  let {
    productId,
    drawNumber
  } = _ref;
  const analyses = await getDrawAnalyses({
    count: 20,
    id: drawNumber,
    product: productId,
    withLegacyFilter: false
  });
  const normalisedGameAnalyses = normalizeAnalyses(analyses.result);
  const normalizedDrawData = normalizeDrawDataFromAnalyseData(normalisedGameAnalyses);
  return {
    normalisedGameAnalyses,
    normalizedDrawData
  };
});
const fetchDrawData = createAsyncThunk('gameAnalyses/fetchDrawData', async _ref2 => {
  let {
    productId,
    drawNumber
  } = _ref2;
  const productName = products.getSpecificDrawName(productId);
  const customHandler = http.get('/draw/1/:product/draws/:drawNumber', _ref3 => {
    let {
      data
    } = _ref3;
    return data;
  }, {
    config: {
      shouldUseCloud: async () => {
        const isEnabled = await featureToggle(cloudApiFeatureToggles[productName.toUpperCase()], {
          req: undefined
        });
        return isEnabled;
      },
      allowedProducts: ['bomben', 'matchen', 'europatipset', 'stryktipset'],
      cloudEndpointTemplate: '/v1/:product/draws/:drawNumber'
    }
  });
  const apiProxy = new ApiProxy([customHandler]);
  const data = await apiProxy.fetch("/draw/1/".concat(productName, "/draws/").concat(drawNumber), {
    method: 'GET',
    req: undefined
  });
  let draw;
  if (data.error) {
    logger.info("Error fetching matchId and participantNames, error: ".concat(data.error));
  } else {
    var _data$draw;
    draw = {
      events: data === null || data === void 0 || (_data$draw = data.draw) === null || _data$draw === void 0 ? void 0 : _data$draw.events
    };
  }
  return normalizeDrawData(draw);
});
const setDrawData = createAction('gameAnalyses/setDrawData');
setGlobal('svs.components.sportinfo.gameAnalysesRedux.actions', {
  fetchDrawAnalyses,
  fetchDrawData,
  setDrawData
});

 })(window);